import React, {FunctionComponent, MouseEvent} from 'react';
import './ListItem.less';

interface ListItemProps {
	isResponsive?: boolean,
	isIncreasedBorderPadding?: boolean,
	onClick?: (e: MouseEvent) => void
}

export const ListItem: FunctionComponent<ListItemProps> = ({children, isResponsive, isIncreasedBorderPadding, onClick}) => {
	return (<li className={`list-item ${
		onClick ? 'list-item--clickable' : ''
	} ${
		isResponsive ? 'list-item--responsive' : ''
	} ${
		isIncreasedBorderPadding ? 'list-item--increased-border-padding' : ''
	}`}
							onClick={typeof onClick === 'function' ? onClick : undefined}>
		{children}
	</li>);
};
